<template>
   <div class="px-3 py-3" style="font-family: 'Roboto', sans-serif;">
      <div class="mb-4">
         <div class="row gx-2 mb-3">
            <div class="col-6">
               <label class="form-label text-muted fw-bold mb-1" style="font-size: 11px; text-transform: uppercase;">Date Range</label>
               <datepicker auto-apply :enable-time-picker="false" position="left" placeholder="All Time" format="dd-MMM-yyyy"
                  :teleport="true" input-class-name="form-control shadow-none" v-model="filterByDate" range>
               </datepicker>
            </div>
            <div class="col-6">
               <label class="form-label text-muted fw-bold mb-1" style="font-size: 11px; text-transform: uppercase;">Activity Type</label>
               <select v-model="filterByActivity" class="form-select shadow-none">
                  <option value="none" selected>All Activities</option>
                  <option v-for="activity in activities" :key="activity.id" :value="activity.id">{{ activity.display_name }}</option>
               </select>
            </div>
         </div>

         <div class="mb-4">
            <label class="form-label text-muted fw-bold mb-1" style="font-size: 11px; text-transform: uppercase;">Search Logs</label>
            <input v-model.trim="search" type="text" class="form-control shadow-none" placeholder="Search activity..." @keyup="onSearch()" />
         </div>
      </div>

   <!-- <form class="row g-0" style="gap: 0.5rem">
 
       <div class="form-floating">
          <textarea ref="addNoteRef" class="form-control add-note-textarea" id="enquiryDetails"
             v-model.trim="enquiryDetails" placeholder="Write additional notes..."
             oninput="this.style.height = this.scrollHeight + 2 + 'px'"></textarea>
          <label for="enquiryDetails" class="text-muted">Write additional update/notes...</label>
       </div>
 
       <div class="mb-3 text-end">
          <button type="button" class="btn btn-warning text-light" @click="createLeadNote(lead.id)"
             :disabled="disableAddNoteButton()"> New Update </button>
       </div>
    </form> -->

      <Timeline ref="timelineRef" :timeline-items="dataTimeline" :message-when-no-items="messageWhenNoItems"
         style="white-space: pre-wrap;">
         <template #activity="{ data }">
            <p class="activity-title" :title="`Activity Type: ` + data.activity_type">{{ data.activity_title }}</p>
            <div>
               <span class="activity-details">{{ data.activity_details }}</span>
            </div>
         </template>
      </Timeline>
   </div>
</template>

<script>
import moment from "moment";
import { toTitleCase } from '@/plugins/helper.js'
import Timeline from '@/components/Timeline/Timeline.vue'
import { debounce, log } from '@/plugins/helper.js'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import '@/assets/css/vue-datetimepicker.css'
//import DatePicker from 'vue3-datepicker';

export default {

   components: {
      Timeline,
      //VueDatePicker,
      Datepicker
   },

   data() {
      return {
         search: "",
         proposalActivities: [],
         proposalActivity: {
            id: '',
            activityType: '',
            activityDetails: '',
            createdBy: 0,
         },
         currentDate: null,
         debounceFn: null,
         messageWhenNoItems: 'There are no items',
         activities: [
            { id: "proposal_create", display_name: "Proposal Creation" },
            { id: "proposal_update", display_name: "Proposal Updated" },
            { id: "proposal_status_change", display_name: "Status Change" },
            { id: "proposal_sent", display_name: "Proposal Sent" },
            { id: "proposal_question", display_name: "Client Revisions & Questions" },
            { id: "proposal_accepted", display_name: "Proposal Accepted" },
            { id: "proposal_declined", display_name: "Proposal Declined" },
            { id: "proposal_reissue", display_name: "Proposal Reissue Request" },
         ],
         filterBy: "",
         filterByActivity: "none",
         filterByUser: "none",
         filterByDate: null,
         filterByList: [
            { text: "None", value: "" },
            { text: "User", value: "user" },
            { text: "Activity", value: "activity" },
         ],
         filterValueOptions: [],
         filtering: {
            field: "",
            value: ""
         },
         dateRange: null,
         proposalID: 0,
         vtxUsers: [],
      }

   },

   created() {
      this.getVertexUsers()
   },

   computed: {

      dataTimeline() {
         if (this.proposalActivities.length > 0) {

            this.proposalActivities.forEach((activity) => {
               if (activity.activity_type.includes("proposal_create")) {
                  activity.activity_title = "Proposal Creation"
               }
               if (activity.activity_type.includes("proposal_update")) {
                  activity.activity_title = "Proposal Updated"
               }
               if (activity.activity_type.includes("proposal_sent")) {
                  activity.activity_title = "Proposal Sending"
               }
               if (activity.activity_type.includes("proposal_status_change")) {
                  activity.activity_title = "Proposal Status Change"
               }
               if (activity.activity_type.includes("proposal_resent")) {
                  activity.activity_title = "Proposal Resending"
               }
               if (activity.activity_type.includes("proposal_shared")) {
                  activity.activity_title = "Proposal Shared"
               }
               if (activity.activity_type.includes("proposal_question")) {
                  activity.activity_title = "Proposal Client Question"
               }
               if (activity.activity_type.includes("proposal_accepted")) {
                  activity.activity_title = "Proposal Accepted"
               }
                if (activity.activity_type.includes("proposal_revoked")) {
                  activity.activity_title = "Proposal Shared Access Revoked"
               }
                if (activity.activity_type.includes("proposal_extended")) {
                  activity.activity_title = "Proposal Extended"
               }
                 if (activity.activity_type.includes("proposal_expired")) {
                  activity.activity_title = "Proposal Expired"
               }
                if (activity.activity_type.includes("proposal_declined")) {
                  activity.activity_title = "Proposal Declined"
               }
                  if (activity.activity_type.includes("proposal_reissue")) {
                  activity.activity_title = "Proposal Reissue Request"
               }
            })

         }

         return this.proposalActivities
      },

      filterByField() {
         return this.filterBy
      },
   },

   watch: {

      filterByUser() {
         this.debounceFn(this.proposalID)
      },

      filterByActivity() {
         this.debounceFn(this.proposalID)
      },

      filterByDate() {
         //   if (this.filterByDate != null)
         this.debounceFn(this.proposalID)
      },

      filterByField() {
         this.setFilterOptions(this.filterBy)
         this.filtering.field = this.filterBy
         if (this.filterBy == "user") {
            this.filterByUser = "none"
            this.filterByActivity = "none"
         } else if (this.filterBy == "activity") {
            this.filterByActivity = "none"
            this.filterByUser = "none"
         }
      },

   },

   methods: {
      init(id) {
         this.filterByDate = null
         this.proposalID = id
         this.proposalActivities = []
         this.currentDate = moment(new Date()).format("DD-MMM-YYYY");
         this.getProposalActivities(id)
         this.debounceFn = debounce((proposalID) => this.getProposalActivities(proposalID), 500)
      },

      formatDate(date, type) {
         if (type == "full") {
            return moment(date).format("DD-MMM-YYYY h:mm A")
         } else {
            return moment(date).format("DD-MMM-YYYY")
         }

      },

      formatToTitleCase(str) {
         return toTitleCase(str)
      },

      triggerDebounce() {
         this.debounceFn(this.proposalID)
      },


      preventKeyPress: function (evt) {
         evt = (evt) ? evt : window.event;
         evt.preventDefault();
      },


      async getProposalActivities(id) {
         let apiPath = "/proposals/" + id + "/activities?"

         if (this.search != "") {
            apiPath += "search=" + this.search
         }

         if (this.filterByActivity != "" && this.filterByActivity != "none") {
            apiPath += "&activity=" + this.filterByActivity
         }

         if (this.filterByUser != "" && this.filterByUser != "none") {
            apiPath += "&user=" + this.filterByUser
         }


         //console.log(this.filterByDate)
         if (this.filterByDate != null) {
            this.filterByDate[0] = this.convertToUTC(this.filterByDate[0])
            this.filterByDate[1] = this.convertToUTC(this.filterByDate[1])
            let tz = Intl.DateTimeFormat().resolvedOptions().timeZone
            apiPath += "&search_date_from=" + this.filterByDate[0] + "&search_date_to=" + this.filterByDate[1] + "&search_tz=" + tz
         }

         await this.$axios.get(apiPath)
            .then((response) => {
               this.proposalActivities = []
               this.proposalActivities = response.data.items
               log(this.proposalActivities)
               this.getUser()

            })
            .catch((error) => {
               this.$toast.error(error.response.data.message)
            })
      },

      convertToUTC(timestampWithTimezone) {
         const date = new Date(timestampWithTimezone);
         // Get the ISO string (e.g., "2025-05-27T14:22:36.000Z")
         const isoString = date.toISOString();
         // Split at "T" and take the first part (the date)
         return isoString.split('T')[0]; // Returns "2025-05-27"
      },

      // Call get users api in Auth
      async getAuthUser(id, index) {
         await this.$axios_auth.get("/users/" + id)
            .then((response) => {
               if (response.data.user) {
                  let user = {
                     firstName: response.data.user.first_name,
                     lastName: response.data.user.last_name
                  }
                  this.leadNotes[index].user = user
               } else if (response.data.user == null && id != "") {
                  this.leadNotes[index].user = {
                     firstName: "Deleted",
                     lastName: "User"
                  }
               } else {
                  this.leadNotes[index].user = {
                     firstName: "System",
                     lastName: "Generated"
                  }
               }
            })
            .catch((error) => {
               this.$toast.error(error.response.data.message)
            })
      },

      async getVertexAuthUser(id, index) {
         //let vtxUsers = this.$store.state.auth.usersWithVertexRoles
         let user = Array.isArray(this.vtxUsers) ? this.vtxUsers.find(user => user && user.id === id) : null;

         log("USER:", this.vtxUsers)
         log("USER ID:", id)
         log("USER:", user)


         if (user) {
            this.proposalActivities[index].user = {
               firstName: user.first_name,
               lastName: user.last_name
            }
         } else if (user == null && id != "") {
            this.proposalActivities[index].user = {
               firstName: "Deleted",
               lastName: "User"
            }
         } else {
            this.proposalActivities[index].user = {
               firstName: "System",
               lastName: "Generated"
            }
         }
      },

      getVertexUsers() {
         this.vtxUsers = this.$store.state.auth.usersWithVertexRoles || []
         //  await this.$axios_auth.get("/supadmin/users")
         //     .then((response) => {
         //        sortAlphabetically(response.data.users, (item) => item.user.first_name)
         //        this.vtxUsers = response.data.users
         //        //this.$store.commit("auth/setUsersWithVertexRoles", response.data.users)
         //        //console.log(this.$store.state.auth.usersWithVertexRoles)
         //     })
         //     .catch((error) => {
         //        console.error(error)
         //        // this.$toast.error(error.response.data.message)
         //     })
      },


      // loop through the notes and get user 
      getUser() {
         for (let i in this.proposalActivities) {

            log(i)


            let userId = this.proposalActivities[i].created_by
            this.getVertexAuthUser(userId, i)
         }
      },

      onSearch() {
         this.debounceFn(this.proposalID)
      },

      toggleFilterForm() {
         if (this.filterByActivity == "none" && this.filterByUser == "none") {
            this.clearFilter()
         }
      },

      clearFilter() {
         this.filterBy = ""
         this.filterByActivity = "none"
         this.filterByUser = "none"
         this.filtering.field = ""
         this.filtering.value = ""
         this.debounceFn(this.proposalID)
      },

      setFilterOptions(filter_field) {
         switch (filter_field) {
            case "user": {
               this.filterValueOptions = [{
                  id: "none",
                  name: "All"
               }, {
                  id: "0",
                  name: "System Generated"
               }]

               this.$store.state.auth.usersWithVertexRoles.forEach((s) => {
                  this.filterValueOptions.push({
                     id: s.user.id,
                     name: s.user.first_name + " " + s.user.last_name,
                  })
               })
               return;
            }
            case "activity": {
               this.filterValueOptions = [{
                  id: "none",
                  name: "All"
               },
               { id: "auth_org_link", name: "Auth Organisation Link" },
               { id: "cold_lead", name: "Cold Lead" },
               { id: "initial_note", name: "Initial Note" },
               { id: "initial_note_internal", name: "Initial Note - Internal" },
               { id: "initial_note_pentest", name: "Initial Note - Pentest" },
               { id: "initial_note_website", name: "Initial Note - Website" },
               { id: "initial_status", name: "Initial Status" },
               { id: "initial_status_internal", name: "Initial Status - Internal" },
               { id: "initial_status_pentest", name: "Initial Status - Pentest" },
               { id: "initial_status_website", name: "Initial Status - Website" },
               { id: "loss_reason", name: "Loss Reason" },
               { id: "New", name: "New" },
               { id: "note", name: "Note" },
               { id: "priority", name: "Priority" },
               { id: "proposal_revision", name: "Proposal Revision" },
               { id: "proposal_upload", name: "Proposal Upload" },
               { id: "status", name: "Status" }
               ]
               return;
            }
         }
      },
   },
};

</script>

<style scoped>
.add-note-textarea {
   height: 80px;
   /* width: 640px; */
   border-radius: 10px;
   border: 1px solid #D9D9D9;
   color: #435666;
}

.activity-textarea {
   border-radius: 10px;
   border: 1px solid #D9D9D9;
   color: #435666;
}

.status,
.priority,
.initial_status,
.initial_status_internal,
.initial_status_pentest,
.initial_status_website,
.auth_org_link {
   font-style: italic;
   font-size: 12px;
}

.note,
.initial_note,
.initial_note_internal,
.initial_note_pentest,
.initial_note_website,
.loss_reason {
   font-size: 13px;
}

.prevStatus {
   color: #F3994D;
}

.newStatus {
   color: #00A54F;
}

.high {
   color: #EB1C24;
}

.low {
   color: #00A54F;
}

.medium {
   color: #F3994D;
}

/* .auth_org_link_details{
    color: #00A0C1;
 } */

.activity-item {
   width: auto;
   border-radius: 0px 5px 5px 5px;
   border: 1px solid #435666;
}
</style>